import React from 'react'
import { useState } from 'react'
import CustomSelect from '../../components/atoms/Inputs/CustomSelect'
import CustomInput from '../../components/atoms/Inputs/CustomInput'
import PrimaryButton from '../../components/atoms/PrimaryButton'
import { useFormik } from 'formik'
import CustomDatePicker from '../../components/atoms/Inputs/CustomDatePicker'
import csc from 'country-state-city'
import moment from 'moment'
import { isAuthenticated } from '../../Utils/Auth'
import { useTranslation } from 'react-i18next'

const CarRegisterRegistrationNumber = ({ formik, nextStep, prevStep, loader }) => {
    const { t } = useTranslation()
    console.log('Authentication -', isAuthenticated())
    return (
        <>
            <h2 className="text-left light-white mb-3">{t('sell_your_car')}!</h2>
            {/* <CustomInput
                label="Title"
                type="text"
                inputClassName="input-login login-user-name"
                labelClass="login-user-name-label light-white"
                placeholder=""
                onChange={formik.handleChange}
                name="title"
                value={formik.values.title}
                onBlur={formik.handleBlur}
                helperText={
                    formik.touched.title && formik.errors.title ? formik.errors.title : null
                }
                error={formik.touched.title && formik.errors.title}
            />

            <CustomInput
                label="Description"
                type="text"
                inputClassName="input-login login-user-name"
                labelClass="login-user-name-label light-white"
                placeholder=""
                onChange={formik.handleChange}
                name="description"
                value={formik.values.description}
                onBlur={formik.handleBlur}
                helperText={
                    formik.touched.description && formik.errors.description
                        ? formik.errors.description
                        : null
                }
                error={formik.touched.description && formik.errors.description}
            />
            <CustomSelect
                id="country"
                placeholder="Select Country"
                label="Country"
                name="country"
                value={formik.values.country}
                onChange={(event) => formik.setFieldValue('country', event.target.value)}
                selectClassName="customSelect"
                labelClass="text-left light-white"
                onBlur={formik.handleBlur}
                helperText={
                    formik.touched.country && formik.errors.country ? formik.errors.country : null
                }
                error={formik.touched.country && formik.errors.country}
            >
                {csc.getAllCountries().map((option) => (
                    <option key={option.id} value={option.id}>
                        {option.name}
                    </option>
                ))}
            </CustomSelect>
            <CustomSelect
                id="state"
                placeholder="Select State"
                label="State"
                name="state"
                value={formik.values.state}
                onChange={(event) => formik.setFieldValue('state', event.target.value)}
                selectClassName="customSelect"
                labelClass="text-left light-white"
                onBlur={formik.handleBlur}
                helperText={
                    formik.touched.state && formik.errors.state ? formik.errors.state : null
                }
                error={formik.touched.state && formik.errors.state}
            >
                {csc.getStatesOfCountry(formik.values.country).map((option) => (
                    <option key={option.id} value={option.id}>
                        {option.name}
                    </option>
                ))}
            </CustomSelect>
            <CustomInput
                label="City"
                type="text"
                inputClassName="input-login login-user-name"
                labelClass="login-user-name-label light-white"
                placeholder=""
                onChange={formik.handleChange}
                name="city"
                value={formik.values.city}
                onBlur={formik.handleBlur}
                helperText={formik.touched.city && formik.errors.city ? formik.errors.city : null}
                error={formik.touched.city && formik.errors.city}
            />
            <CustomInput
                label="Description"
                type="text"
                inputClassName="input-login login-user-name"
                labelClass="login-user-name-label light-white"
                placeholder=""
                onChange={formik.handleChange}
                name="description"
                value={formik.values.description}
                onBlur={formik.handleBlur}
                helperText={
                    formik.touched.description && formik.errors.description
                        ? formik.errors.description
                        : null
                }
                error={formik.touched.description && formik.errors.description}
            />
            <CustomInput
                label="Zip Code"
                type="text"
                inputClassName="input-login login-user-name"
                labelClass="login-user-name-label light-white"
                placeholder=""
                onChange={formik.handleChange}
                name="zipcode"
                value={formik.values.zipcode}
                onBlur={formik.handleBlur}
                helperText={
                    formik.touched.zipcode && formik.errors.zipcode ? formik.errors.zipcode : null
                }
                error={formik.touched.zipcode && formik.errors.zipcode}
            />
            <CustomInput
                label="Phone Number"
                type="text"
                inputClassName="input-login login-user-name"
                labelClass="login-user-name-label light-white"
                placeholder=""
                onChange={formik.handleChange}
                name="phonenumber"
                value={formik.values.phonenumber}
                onBlur={formik.handleBlur}
                helperText={
                    formik.touched.phonenumber && formik.errors.phonenumber
                        ? formik.errors.phonenumber
                        : null
                }
                error={formik.touched.phonenumber && formik.errors.phonenumber}
            /> */}
            <CustomInput
                label={t('registration_number')}
                type="text"
                inputClassName="input-login login-user-name"
                labelClass="login-user-name-label light-white"
                placeholder="ABC12D"
                onChange={formik.handleChange}
                name="regNum"
                value={formik.values.regNum}
                onBlur={formik.handleBlur}
                helperText={
                    formik.touched.regNum && formik.errors.regNum ? formik.errors.regNum : null
                }
                error={formik.touched.regNum && formik.errors.regNum}
                inputProps={{ style: { textTransform: 'uppercase' } }}
            />
            <CustomInput
                label={t('mileage')}
                type="number"
                inputClassName="input-login login-password"
                labelClass="login-password-label light-white"
                placeholder="12,345"
                endAdornment="mil"
                onChange={formik.handleChange}
                name="mileage"
                value={formik.values.mileage}
                helperText={
                    formik.touched.mileage && formik.errors.mileage ? formik.errors.mileage : null
                }
                error={formik.touched.mileage && formik.errors.mileage}
            />
            {/* <div className="login-confirm-area mb-4">
                <p className="text-left">
                    *We only accept cars sold in Sweden that have driven a maximum of 20,000 miles.
                    We do not accept taxis.
                </p>
            </div> */}
            {/* <CustomDatePicker
                label="Start Date"
                name="start_date"
                id="start_date"
                inputClassName="input-login login-user-name"
                labelClass="login-user-name-label light-white"
                dateFormat={'MMMM DD, yyyy h:mm a'}
                onChange={(date) => {
                    formik.setFieldValue('start_date', date)
                    if (formik.values.end_date && moment(formik.values.end_date).isBefore(date)) {
                        formik.setFieldValue('end_date', null)
                    }
                }}
                minDate={new Date()}
                value={formik.values.start_date}
                onBlur={formik.handleBlur}
                helperText={
                    formik.touched.start_date && formik.errors.start_date
                        ? formik.errors.start_date
                        : null
                }
                error={formik.touched.start_date && formik.errors.start_date}
            />
            <CustomDatePicker
                label="End Date"
                name="end_date"
                id="end_date"
                inputClassName="input-login login-user-name"
                labelClass="login-user-name-label light-white"
                dateFormat={'MMMM DD, yyyy h:mm a'}
                onChange={(date) => {
                    formik.setFieldValue('end_date', date)
                }}
                minDate={formik.values.start_date ? formik.values.start_date : new Date()}
                value={formik.values.end_date}
                onBlur={formik.handleBlur}
                helperText={
                    formik.touched.end_date && formik.errors.end_date
                        ? formik.errors.end_date
                        : null
                }
                error={formik.touched.end_date && formik.errors.end_date}
            /> */}
            <div className="login-butto mt-4">
                <PrimaryButton
                    customClassName="login-confirm-btn"
                    label={loader ? 'Please Wait...' : t('start_here')}
                    iconRight={<span className="material-icons">arrow_right_alt</span>}
                    type="button"
                    onClick={nextStep}
                    disabled={loader}
                />
            </div>
        </>
    )
}

export default CarRegisterRegistrationNumber
